define('companiesDetailBodyInfoView',[
  'app',
  'module',
  'marionette',
  'underscore',
  'bootbox',
  'template!companiesDetailBodyInfoView'
], function (
  App,
  Module,
  Marionette,
  _,
  bootbox,
  Tpl
) {
  'use strict';

  Module.exports = Marionette.ItemView.extend({
    template: Tpl,
    className: 'companies-detail-info-view',

    ui: {
      webSite: '.js-webSite',
      industry: '.js-industry',
      linkedIn: '.js-linkedIn',
      companyPhone: '.js-companyPhone',
      foundedYear: '.js-foundedYear',
      employees: '.js-employees',
      annualRevenue: '.js-annualRevenue',
      totalFunding: '.js-totalFunding',
      save: '.js-save',
      reloadApollo: '.js-reload-apollo',
      apolloIcon: '.js-apollo-icon'
    },

    events: {
      'click @ui.save': 'onSave',
      'click @ui.reloadApollo': 'onReloadApollo'
    },

    // Re-render when the model changes (e.g. after a successful save the server
    // echoes back the persisted company).
    modelEvents: {
      'sync': 'render'
    },

    // Trim a text input, returning null when empty so we don't store empty strings.
    textVal: function ($input) {
      var value = ($input.val() || '').trim();
      return value === '' ? null : value;
    },

    // Parse a numeric input, returning null when empty/invalid.
    numberVal: function ($input) {
      var raw = ($input.val() || '').trim();
      if (raw === '') {
        return null;
      }
      var value = Number(raw);
      return isNaN(value) ? null : value;
    },

    onSave: function () {
      var attrs = {
        // The name is required by the backend update endpoint; keep the current one.
        name: this.model.get('name'),
        webSite: this.textVal(this.ui.webSite),
        industry: this.textVal(this.ui.industry),
        linkedIn: this.textVal(this.ui.linkedIn),
        companyPhone: this.textVal(this.ui.companyPhone),
        foundedYear: this.numberVal(this.ui.foundedYear),
        employees: this.numberVal(this.ui.employees),
        annualRevenue: this.numberVal(this.ui.annualRevenue),
        totalFunding: this.numberVal(this.ui.totalFunding)
      };

      this.ui.save.prop('disabled', true);
      this.model.save(attrs, { wait: true })
        .done(_.bind(function () {
          App.trigger('notification:success', _.i18n('common.changesSaved', null, 'Changes saved'));
        }, this))
        .fail(_.bind(function () {
          App.trigger('notification:error', _.i18n('common.error', null, 'An error occurred'));
        }, this))
        .always(_.bind(function () {
          if (!this.isDestroyed) {
            this.ui.save.prop('disabled', false);
          }
        }, this));
    },

    // Re-fetch the company from Apollo.io. The backend replaces the stored values with
    // Apollo's, so unsaved edits in the form are lost too — hence the confirmation.
    onReloadApollo: function () {
      bootbox.confirm(
        _.i18n('companies.info.confirmReloadApollo', null,
          'Reload this company from Apollo.io? The fields below will be replaced by Apollo\'s data.'),
        _.bind(function (result) {
          if (result) {
            this.reloadFromApollo();
          }
        }, this));
    },

    reloadFromApollo: function () {
      this.setApolloLoading(true);
      App.request('company:enrich', this.model.get('secId'))
        .done(_.bind(function (resp) {
          if (this.isDestroyed) {
            return;
          }
          if (resp && resp.enriched) {
            this.model.set(resp.company);
            this.render();
            App.trigger('notification:success',
              _.i18n('companies.info.apolloReloaded', null, 'Company reloaded from Apollo'));
          } else {
            App.trigger('notification:error',
              _.i18n('companies.info.apolloNoData', null, 'Apollo has no data for this company'));
          }
        }, this))
        .fail(_.bind(function (xhr) {
          var message = xhr && xhr.status === 503 ?
            _.i18n('companies.info.apolloNotConfigured', null, 'The Apollo.io integration is not configured') :
            _.i18n('common.error', null, 'An error occurred');
          App.trigger('notification:error', message);
        }, this))
        .always(_.bind(function () {
          if (!this.isDestroyed) {
            this.setApolloLoading(false);
          }
        }, this));
    },

    // Spin the button icon and lock both actions while the lookup is running.
    setApolloLoading: function (loading) {
      this.ui.reloadApollo.prop('disabled', loading);
      this.ui.save.prop('disabled', loading);
      this.ui.apolloIcon
        .toggleClass('mdi-navigation-refresh', !loading)
        .toggleClass('mdi-action-autorenew icon-spin', loading);
    }
  });
});

